// OperationModels.tsx
/* eslint-disable @next/next/no-img-element */
import * as React from "react";
import {
    Box,
    Chip,
    Divider,
    Grid,
    Paper,
    Stack,
    Typography,
    Button,
} from "@mui/material";
import Heading from "../heading";
import CostBreakdownTable from './ParticipationCostBreakdownTable'
import QuadrantPartners from './QuadrantPartners'
import CtaButton from "../buttonWithArrow";
import Image from "next/image";

const MAX_W = 1240;


const MODELS = {
    INVESTOR: {
        rows: [
            { item: "Car Insurance", amount: "As per value" },
            { item: "Registration Fee", amount: "2,100" },
            { item: "RMS Tracking", amount: "3,900" },
        ],
        total: "6,000.00",
    },
    RSL: {
        rows: [
            { item: "Car Insurance", amount: "As per value" },
            { item: "Registration Fee", amount: "2,100" },
            { item: "RMS Tracking", amount: "3,900" },
        ],
        total: "6,000.00",
    },
};

const Q1 = [
    "Rentalcars.com",
    "DiscoverCars.com",
    "Expedia.com",
    "OneClickDrive.com",
    "ekar",
    "Hertz.com",
];
const Q2 = [
    "Kayak.com",
    "Priceline.com",
    "Skyscanner.com",
    "Avis.com",
    "Europcar.com",
    "Enterprise.com",
];
const Q3 = [
    "Booking.com",
    "Trip.com",
    "Opodo",
    "Sixt.com",
    "Budget.com",
    "Thrifty.com",
];
const Q4 = [
    "eZhire",
    "Udrive",
    "Selfdrive.ae",
    "Payless.com",
    "Alamo.com",
    "Nationalcar.com",
];

/* --------- Component --------- */
export default function OperationModels({ data, onClick, bgcolor }) {
    const [tab, setTab] = React.useState(null);
    // const data = MODELS[tab];
    const { title, subtitle, tabData, tableData, tableFooter, bottomHeader, bottomSubHeader, button, bottomData } = data;

    React.useEffect(() => {
        if (tabData && tabData?.length > 0) {
            setTab(tabData[0])
        }
    }, [tabData])

    return (
        <Box component="section" sx={{ py: { xs: 8, md: 4 }, px: { xs: 2, sm: 3 }, background: bgcolor ? bgcolor : "#f5f5f5" }}>
            {/* Header */}
            <Heading title={title} subtitle={subtitle} mb={4} />

            <Box sx={{
                maxWidth: 750, mx: "auto", py: 4,
                px: 2,
            }}>
                <CostBreakdownTable data={tableData} footerData={tableFooter} surfaceColor="#ffffff" />
            </Box>

            {/* CTA */}
            {
                button && <Stack alignItems="center" sx={{ mt: { xs: 2, md: 2 } }}>
                    <CtaButton label={button?.text} onClick={() => onClick()} />
                    {/* <CtaButton cta={{ label: button?.text, href: button?.link }} /> */}
                </Stack>
            }
        </Box>
    );
}

/* --------- Helpers --------- */
const pillSx = (active) => ({
    flexShrink: 0,
    fontWeight: 700,
    borderRadius: "999px",
    px: { xs: 1.5, md: 2.5 },
    py: { xs: 1, md: 3 },
    fontSize: { xs: 14, md: 16 },
    background: active
        ? "linear-gradient(180deg, #75c4c5 0%, #0d8196 100%)"
        : "#fff",
    color: active ? "#fff" : "#000",
    "&:hover": {
        background: active
            ? "linear-gradient(180deg, #4bb6b4 0%, #249f9c 100%)"
            : "#f7f9f9",
    },
    "& .MuiChip-label": { px: 0, fontWeight: 700 },
});
